export const MODAL_SIZES = {
  s: 470,
  m: 600,
};
